export default {
  setNotes(state, notes) {
    state.notes = notes
  },
  setLoading(state, loading) {
    state.loading = loading
  },
}
